import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Panel, Pill, inputClass, buttonClass } from "../components/Bits";
import { adminApi, apiError } from "../adminApi";

const th = "px-3 py-2 text-left font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40";
const td = "px-3 py-2 text-sm text-cream/80";
export const when = (iso) => (iso
  ? new Date(iso).toLocaleString("en-US", { timeZone: "America/Chicago", dateStyle: "medium", timeStyle: "short" })
  : "—");

export const Tabs = ({ active }) => (
  <nav className="flex flex-wrap gap-2" data-testid="pb-tabs">
    {[["Builder", "/admin/plan-builder"], ["Saved scenarios", "/admin/plan-builder/scenarios"],
      ["Plan Check leads", "/admin/plan-builder/leads"]].map(([text, to]) => (
      <Link key={to} to={to}
        data-testid={`pb-tab-${text.split(" ")[0].toLowerCase()}`}
        className={`border px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] ${
          active === text ? "border-gold bg-gold/10 text-gold" : "border-cream/15 text-cream/50 hover:text-cream"}`}>
        {text}
      </Link>
    ))}
  </nav>
);

export default function AdminPlanScenarios() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");

  const load = useCallback(async () => {
    try {
      const { data } = await adminApi.get(`/crm/plan-builder/scenarios${q ? `?q=${encodeURIComponent(q)}` : ""}`);
      setRows(data.scenarios);
    } catch (e) { toast.error(apiError(e)); }
  }, [q]);

  useEffect(() => { load(); }, [load]);

  const act = async (id, kind) => {
    if (kind === "delete" && !window.confirm("Delete this scenario? This cannot be undone.")) return;
    try {
      if (kind === "delete") await adminApi.delete(`/crm/plan-builder/scenarios/${id}`);
      else await adminApi.post(`/crm/plan-builder/scenarios/${id}/duplicate`);
      toast.success(kind === "delete" ? "Scenario deleted." : "Scenario duplicated.");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-6" data-testid="plan-scenarios">
      <h1 className="font-serif text-2xl font-medium text-cream">Group Plan Builder</h1>
      <Tabs active="Saved scenarios" />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by company"
        className={inputClass} data-testid="pb-scenario-search" />
      <Panel title="Saved scenarios" testid="pb-scenarios-panel">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px]">
            <thead className="border-b border-cream/10"><tr>
              {["Name", "Client", "Top option", "Plan year", "Status", "Updated", "Lead", ""].map((h) => <th key={h} className={th}>{h}</th>)}
            </tr></thead>
            <tbody className="divide-y divide-cream/5">
              {(rows || []).map((s) => (
                <tr key={s.id} data-testid={`pb-scenario-${s.id}`}>
                  <td className={td}><Link to={`/admin/plan-builder/scenarios/${s.id}`} className="hover:text-gold">{s.name}</Link></td>
                  <td className={td}>{s.client_company}</td>
                  <td className={td}>{(s.result_snapshot?.top3 || [])[0]?.name || "—"}</td>
                  <td className={td}>{s.inputs?.year || "—"}</td>
                  <td className={td}><Pill tone={s.status === "presented" ? "good" : "neutral"}>{s.status}</Pill></td>
                  <td className={td}>{when(s.updated_at)}</td>
                  <td className={td}>{s.lead_id
                    ? <Link to={`/admin/plan-builder/leads/${s.lead_id}`} className="hover:text-gold">Plan Check</Link> : "—"}</td>
                  <td className={`${td} whitespace-nowrap`}>
                    <Link to={`/admin/plan-builder/scenarios/${s.id}`} className="mr-3 hover:text-gold">Open</Link>
                    <button onClick={() => act(s.id, "duplicate")} className="mr-3 hover:text-gold" data-testid={`pb-dup-${s.id}`}>Duplicate</button>
                    <button onClick={() => act(s.id, "delete")} className="hover:text-terra" data-testid={`pb-del-${s.id}`}>Delete</button>
                  </td>
                </tr>
              ))}
              {rows && !rows.length ? (
                <tr><td className={td} colSpan={8} data-testid="pb-scenarios-empty">No scenarios saved yet.</td></tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </Panel>
      <Link to="/admin/plan-builder" className={buttonClass} data-testid="pb-new-scenario">Open the builder</Link>
    </div>
  );
}
